import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TermosUso = () => {
  useEffect(() => {
    document.title = "Termos de Uso - 30 Receitas Express";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header hideCheckoutButton />
      <main className="py-12 md:py-16">
        <div className="container max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Termos de Uso</h1>
          <p className="text-sm text-muted-foreground mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Aceitação dos Termos</h2>
              <p className="text-muted-foreground leading-relaxed">
                Ao acessar e adquirir o e-book "30 Receitas Express (30 min)" ("Produto"), você concorda em cumprir e estar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar nosso serviço.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Descrição do Produto</h2>
              <p className="text-muted-foreground leading-relaxed">
                O "30 Receitas Express" é um e-book digital contendo 30 receitas práticas de almoço que podem ser preparadas em até 30 minutos, utilizando ingredientes simples e acessíveis. O produto é entregue em formato PDF digital.
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                O e-book inclui:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>30 receitas completas com instruções passo a passo</li>
                <li>Lista de ingredientes para cada receita</li>
                <li>Tempo de preparo estimado</li>
                <li>Dicas e sugestões de preparo</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Compra e Pagamento</h2>
              <p className="text-muted-foreground leading-relaxed">
                O valor do e-book é de R$ 29,90 (vinte e nove reais e noventa centavos). O pagamento pode ser realizado através dos métodos disponibilizados em nossa plataforma de checkout. Ao finalizar a compra, você receberá:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Confirmação de compra por e-mail</li>
                <li>Link para download do e-book por e-mail</li>
                <li>Mensagem com acesso via WhatsApp (se fornecido)</li>
                <li>Acesso imediato ao arquivo PDF</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Acesso e Entrega</h2>
              <p className="text-muted-foreground leading-relaxed">
                Após a confirmação do pagamento, você receberá acesso imediato ao e-book através do link enviado para o e-mail cadastrado. É sua responsabilidade:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Fornecer informações de contato corretas e atualizadas</li>
                <li>Verificar sua caixa de spam/lixeira caso não receba o e-mail</li>
                <li>Fazer o download e armazenar o arquivo em local seguro</li>
                <li>Manter suas credenciais de acesso em sigilo</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Propriedade Intelectual</h2>
              <p className="text-muted-foreground leading-relaxed">
                Todo o conteúdo do e-book, incluindo mas não limitado a textos, receitas, imagens, layouts e design, é de propriedade exclusiva da 30 Receitas Express e está protegido por leis de direitos autorais.
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                Ao adquirir o e-book, você recebe uma licença não exclusiva, intransferível e limitada para uso pessoal. É expressamente proibido:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Reproduzir, copiar ou distribuir o conteúdo sem autorização prévia</li>
                <li>Modificar, adaptar ou criar obras derivadas</li>
                <li>Vender, revender ou comercializar o e-book</li>
                <li>Compartilhar o arquivo ou link de download com terceiros</li>
                <li>Publicar o conteúdo em sites, blogs ou redes sociais sem permissão</li>
                <li>Utilizar o conteúdo para fins comerciais</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Uso Permitido</h2>
              <p className="text-muted-foreground leading-relaxed">
                Você pode utilizar o e-book exclusivamente para fins pessoais, não comerciais. Você tem permissão para:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Ler e consultar o conteúdo em dispositivos pessoais</li>
                <li>Imprimir cópias para uso pessoal doméstico</li>
                <li>Preparar as receitas para você e sua família</li>
                <li>Fazer backup do arquivo para segurança pessoal</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Garantias e Isenções</h2>
              <p className="text-muted-foreground leading-relaxed">
                As receitas contidas no e-book foram desenvolvidas e testadas com cuidado. No entanto:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Os resultados podem variar de acordo com ingredientes, equipamentos e habilidades individuais</li>
                <li>Não garantimos resultados específicos ou idênticos aos apresentados</li>
                <li>É responsabilidade do usuário verificar alergias e restrições alimentares</li>
                <li>Não nos responsabilizamos por problemas de saúde decorrentes do consumo das receitas</li>
                <li>O tempo de preparo é estimado e pode variar</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Política de Reembolso</h2>
              <p className="text-muted-foreground leading-relaxed">
                Oferecemos garantia de reembolso de 7 dias a partir da data de compra. Para mais informações, consulte nossa{" "}
                <a href="/politica-reembolso" className="text-primary hover:underline">Política de Reembolso</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Limitação de Responsabilidade</h2>
              <p className="text-muted-foreground leading-relaxed">
                Em nenhuma circunstância a 30 Receitas Express será responsável por quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais resultantes do uso ou impossibilidade de uso do e-book, incluindo mas não limitado a:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Perda de lucros ou receitas</li>
                <li>Interrupção de negócios</li>
                <li>Perda de informações ou dados</li>
                <li>Problemas técnicos ou falhas de equipamento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Modificações no Serviço</h2>
              <p className="text-muted-foreground leading-relaxed">
                Reservamo-nos o direito de modificar, atualizar ou descontinuar o e-book a qualquer momento, com ou sem aviso prévio. Não seremos responsáveis perante você ou terceiros por qualquer modificação, suspensão ou descontinuação do serviço.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Violações e Penalidades</h2>
              <p className="text-muted-foreground leading-relaxed">
                A violação destes Termos de Uso, especialmente relacionada à propriedade intelectual e compartilhamento não autorizado, poderá resultar em:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground mt-3">
                <li>Revogação imediata da licença de uso</li>
                <li>Ações legais cabíveis</li>
                <li>Indenização por danos causados</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">12. Alterações nos Termos</h2>
              <p className="text-muted-foreground leading-relaxed">
                Podemos atualizar estes Termos de Uso periodicamente. Notificaremos você sobre mudanças significativas através do e-mail cadastrado. O uso continuado do serviço após as alterações constitui sua aceitação dos novos termos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">13. Lei Aplicável e Jurisdição</h2>
              <p className="text-muted-foreground leading-relaxed">
                Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Qualquer disputa decorrente destes termos será submetida à jurisdição exclusiva dos tribunais brasileiros.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">14. Contato</h2>
              <p className="text-muted-foreground leading-relaxed">
                Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:
              </p>
              <ul className="list-none space-y-2 text-muted-foreground mt-3">
                <li><strong>E-mail:</strong> <a href="mailto:suporte@receitasem30minutos.com.br" className="text-primary hover:underline">suporte@receitasem30minutos.com.br</a></li>
                <li><strong>Empresa:</strong> 30 Receitas Express</li>
              </ul>
            </section>

            <section className="mt-8 p-4 bg-muted/50 rounded-lg border border-border">
              <p className="text-sm text-muted-foreground">
                Ao clicar em "Comprar" ou "Finalizar compra", você reconhece que leu, compreendeu e concorda em estar vinculado a estes Termos de Uso e à nossa Política de Privacidade.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermosUso;
